import { useEffect, useCallback, useState } from 'react';
import { AuthConnector } from '@terragotech/gen5-shared-components';
import { DOC_API_URL } from '../utils/docApiURL';

interface AuthenticatedImage {
  id: string;
  src: string;
  width: number;
  height: number;
}

// TODO: [S5-3775] Replicated from `ImageWithHeaders.tsx`; re-integrate this hook with component.
export const useImageWithAuthentication = (imageId: string) => {
  const [imageData, setImageData] = useState<AuthenticatedImage>();

  const fetchWithAuthentication = useCallback(async () => {
    try {
      const headers = new Headers();
      const token = await AuthConnector.getToken();
      headers.set('Authorization', `Bearer ${token}`);
      const response = await fetch(`${DOC_API_URL}${imageId}`, { headers });
      return response;
    } catch (err) {
      return null;
    }
  }, [imageId]);

  const generateImageData = useCallback(async () => {
    const response = await fetchWithAuthentication();
    if (response) {
      const blob = await response.blob();
      const bmp = await createImageBitmap(blob);
      const { width, height } = bmp;
      bmp.close();

      setImageData({
        id: imageId,
        src: URL.createObjectURL(blob), // TODO: [S5-3775] Need to revoke URL? Potential memory leak.
        width,
        height,
      });
    }
  }, [fetchWithAuthentication]);

  useEffect(() => {
    generateImageData();
  }, [generateImageData]);

  return {
    imageData,
  };
};
